import React, { FC, useState, useCallback, useEffect } from "react";
import { Search, Menu, X, ArrowLeft } from "react-feather";
import { Navbar } from "../../Navbar";
import { Button } from "../../Button";
import menus from "./../../../../utils/menu";
import MessageDropdown from "../../../common/Header/MessageDropdown";
import NotificationDropdown from "../../../common/Header/NotificationDropdown";
import ProfileDropdown from "../../../common/Header/ProfileDropdown";
import NavSearch from "../../../common/Header/NavSearch";
import Logo from "../../../common/Logo";
// import { useAppDispatch, useAppSelector } from "../../redux/hooks";
// import { toggleSidebar, toggleBody } from "../../redux/slices/ui";
import {
  StyledHeader,
  StyledLogo,
  StyledNavbarWrap,
  StyledNavbarMenu,
  StyleNavbarRight,
  StyledNavbarElement,
  StyledNavbarHeader,
  StyledNavbarBody,
  StyledNavbarTitle,
  StyledMenuBtn,
  StyledSidebarBtn,
} from "./style";
// import { useStore } from "react-redux";
import { useStores } from "../../../../hooks/useStores";
import { observer } from "mobx-react";

interface IProps {
  hasSidebar?: boolean;
  sidebarLayout?: 1 | 2;
}

const Header: FC<IProps> = observer(({ hasSidebar, sidebarLayout }) => {
  const { session } = useStores();
  // const dispatch = useAppDispatch();
  // const { sidebar, isBody } = useAppSelector((state) => state.ui);
  const [searchOpen, setSearchOpen] = useState(false);
  const searchHandler = useCallback(() => {
    setSearchOpen((prev) => !prev);
  }, []);

  const [menuOpen, setMenuOpen] = useState(false);
  const sidebarHandler = useCallback((_, isOpen?: "open") => {
    // dispatch(toggleSidebar({ isOpen }));
  }, []);

  const bodyHandler = useCallback(() => {
    // dispatch(toggleBody());
    // dispatch(toggleSidebar({ isOpen: "open" }));
  }, []);

  const menuHandler = useCallback(() => {
    setMenuOpen((prev) => !prev);
    if (menuOpen) {
      sidebarHandler(undefined, "open");
    }
  }, [menuOpen, sidebarHandler]);

  useEffect(() => {
    return () => {
      sidebarHandler(undefined, "open");
      bodyHandler();
    };
  }, [sidebarHandler, bodyHandler]);

  const handleSignOutClick = () => {
    session.resetSession();
  };

  return (
    <>
      <StyledHeader>
        {hasSidebar && sidebarLayout === 1 && (
          <>
            <StyledMenuBtn
              variant="texted"
              onClick={menuHandler}
              $hasSidebar={hasSidebar}
              // $sidebarOpen={sidebar}
              // $bodyOpen={isBody}
              className="menu-btn"
            >
              <Menu size={20} strokeWidth="2.5px" />
            </StyledMenuBtn>
            <StyledSidebarBtn
              variant="texted"
              // onClick={!isBody ? sidebarHandler : bodyHandler}
              // $sidebarOpen={sidebar}
              // $bodyOpen={isBody}
              className="sidebar-btn"
            >
              <ArrowLeft size={20} strokeWidth="2.5px" />
            </StyledSidebarBtn>
          </>
        )}
        {hasSidebar && sidebarLayout === 2 && (
          <>
            <StyledMenuBtn
              variant="texted"
              onClick={menuHandler}
              $hasSidebar={hasSidebar}
              // $sidebarOpen={!sidebar}
            >
              <Menu size={20} strokeWidth="2.5px" />
            </StyledMenuBtn>
            <StyledSidebarBtn
              variant="texted"
              onClick={sidebarHandler}
              // $sidebarOpen={!sidebar}
            >
              <ArrowLeft size={20} strokeWidth="2.5px" />
            </StyledSidebarBtn>
          </>
        )}
        {!hasSidebar && (
          <StyledMenuBtn
            variant="texted"
            onClick={menuHandler}
            $hasSidebar={hasSidebar}
            // $sidebarOpen={!sidebar}
          >
            <Menu size={20} strokeWidth="2.5px" />
          </StyledMenuBtn>
        )}
        <StyledLogo>
          <Logo />
        </StyledLogo>
        <StyledNavbarWrap $isOpen={menuOpen} onClick={menuHandler}>
          <StyledNavbarMenu
            $isOpen={menuOpen}
            onClick={(e) => e.stopPropagation()}
          >
            <StyledNavbarHeader>
              <Logo />
              <Button variant="texted" onClick={menuHandler}>
                <X color="#7987a1" width={20} strokeWidth="2.5px" />
              </Button>
            </StyledNavbarHeader>
            <StyledNavbarBody>
              <StyledNavbarTitle>MAIN NAVIGATION</StyledNavbarTitle>
              <Navbar menus={menus} />
            </StyledNavbarBody>
          </StyledNavbarMenu>
        </StyledNavbarWrap>
        <StyleNavbarRight>
          <StyledNavbarElement ml={["15px", "20px", "30px"]}>
            <ProfileDropdown handleSignOut={handleSignOutClick} />
          </StyledNavbarElement>
        </StyleNavbarRight>
      </StyledHeader>
      <NavSearch isOpen={searchOpen} onClose={searchHandler} />
    </>
  );
});

Header.defaultProps = {
  sidebarLayout: 1,
};

export default Header;
